import React from 'react'
import { NewsBannerFragment } from '@gql'
import { nonNull } from '../../../utils/nonNull'
import { OfferPromotionCarousel } from '../../../components/OfferPromotionCarousel/OfferPromotionCarousel'
import { html } from '../../../utils/htmlParser'

export type BannerProps = {
  data: NewsBannerFragment[]
  imageFallbackUrl?: string
}

const NewsBanner: React.VFC<BannerProps> = ({ data, imageFallbackUrl }) => {
  return (
    <OfferPromotionCarousel>
      {nonNull(data).map((item) => {
        const useNewBanner = item.useNewBanner === true
        const banner = useNewBanner ? item.secondaryPageBanner : item.newsDetailBanner

        return (
          <OfferPromotionCarousel flickitySection key={item.uid} variant={'offer'}>
            <OfferPromotionCarousel image src={banner?.[0]?.image?.[0]?.url ?? imageFallbackUrl} alt="" layout="fill" objectFit="cover" objectPosition="center"/>
            <OfferPromotionCarousel contentSection>
              <OfferPromotionCarousel title>{item.title}</OfferPromotionCarousel>
              {item.newsArticleDescription && (
                <OfferPromotionCarousel description>
                  {html(item.newsArticleDescription)}
                </OfferPromotionCarousel>
              )}
              {item.uri && (
                <OfferPromotionCarousel href={`/${item.uri}`} cta primary buttonColor="orange">
                  Find out more
                </OfferPromotionCarousel>
              )}
            </OfferPromotionCarousel>
          </OfferPromotionCarousel>
        )
      })}
    </OfferPromotionCarousel>
  )
}

export const Banner = React.memo(NewsBanner)